import apiClient from 'core/api/client';
import type {
  AssignableVehicle,
  DriverSession,
  GoOnlineBody,
  LocationBody,
} from 'types/driver.types';

export type { AssignableVehicle, DriverSession, GoOnlineBody, LocationBody };

export const listAssignableVehicles = async (): Promise<AssignableVehicle[]> => {
  const { data } = await apiClient.get<AssignableVehicle[]>(
    '/api/v1/organizations/vehicles/assignable',
  );
  return data;
};

export const getMyDriverSession = async (): Promise<DriverSession | null> => {
  const { data } = await apiClient.get<DriverSession | null>(
    '/api/v1/driver-sessions/me',
  );
  return data;
};

export const startDriverSession = async (body: GoOnlineBody): Promise<DriverSession> => {
  const { data } = await apiClient.post<DriverSession>(
    '/api/v1/driver-sessions',
    body,
  );
  return data;
};

export const updateSessionLocation = async (body: LocationBody): Promise<void> => {
  await apiClient.patch('/api/v1/driver-sessions/me/location', body);
};

export const endDriverSession = async (): Promise<void> => {
  await apiClient.post('/api/v1/driver-sessions/me/offline');
};
